import { isBrowser } from "@builder.io/qwik/build";
import { runInBrowser } from "./browser-runtime/browser.qwik.mjs";
import { shouldForceBrowserRuntimeInNode } from "./should-force-browser-runtime-in-node.qwik.mjs";
const chooseBrowserOrServerEval = (args) => isBrowser || shouldForceBrowserRuntimeInNode({
  shouldLogWarning: true
}) ? runInBrowser(args) : runInBrowser(args);
export {
  chooseBrowserOrServerEval
};
